<template>
  <div class="sp-template">
    <div class="h-title">仓库查货</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="仓库">
              <el-select v-model.lazy="queryForm.warehouseIds" filterable clearable multiple>
                <el-option v-for="(d, i) in warehouses" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单状态">
              <el-select v-model="queryForm.orderStatus" filterable clearable multiple placeholder="选择状态">
                <el-option v-for="(d, i) in tmsOrderStages" :key="i" :label="'已'+d.name" :value="d.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单号">
              <el-input type="textarea" v-model.lazy="orderIds" placeholder="多个订单号用回车分割"></el-input>
            </el-form-item>
          </el-row>
          <el-collapse-transition>
						<div v-show="isSearchMore">
              <el-row>
                <el-form-item label="客户">
                  <el-select v-model="queryForm.customerIds" filterable clearable multiple placeholder="选择客户">
                    <el-option v-for="(d, i) in customers" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="渠道">
                  <el-select v-model="queryForm.productIds" filterable clearable multiple placeholder="选择渠道">
                    <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="开始日期">
                  <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-row>
            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40406)" type="primary" size="small" @click="searchTask()">搜 索</el-button>
            <el-button v-if="in_configs(40406)" size="small" @click="reset()">清 空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
              <b v-if="isSearchMore">隐藏</b>
              <b v-else>切换到</b>高级搜索
            </a>
          </div>
        </el-form>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="queryForm.status" @tab-click="searchTask">
					<el-tab-pane v-if="in_configs(40403)" label="待处理" name="0"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40404)" label="完成" name="1"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40405)" label="异常" name="-1"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button v-if="in_configs(40407)" size="small" @click="exportSku">导出申报品名</el-button>
        </div>
      </div>
      <el-table :data="tableData" border stripe @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column label="仓库">
            <template slot-scope="scope">
                {{warehouseMap[scope.row.warehouseCode]}}
            </template>
        </el-table-column>
        <el-table-column label="客户">
          <template slot-scope="scope">
            {{customerMaps[scope.row.orgOwner]}}
          </template>
        </el-table-column>
        <el-table-column label="渠道">
          <template slot-scope="scope">
            {{channelsMaps[scope.row.product]}}
          </template>
        </el-table-column>

        <el-table-column prop="refNumber" label="客户单号"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            {{tmsOrderStagesMap[scope.row.status]}}
          </template>
        </el-table-column>
        <el-table-column prop="totalCarton" label="货物箱数"></el-table-column>
        <el-table-column label="预报货物类型">
          <template slot-scope="scope">
            {{googsTypeMap[scope.row.goodsType]}}
          </template>
        </el-table-column>

        <el-table-column v-if="queryForm.status!=0"   label="实际类型">
          <template slot-scope="scope">
            {{googsTypeMap[scope.row.changedGoodsType]}}
          </template>
        </el-table-column>
        <el-table-column v-if="queryForm.status==1"   width="150px" label="加收税费">
          <template slot-scope="scope">
            {{scope.row.tax}}{{scope.row.tax && scope.row.units?"(" + scope.row.currency+"/"+scope.row.units + ")":""}}
          </template>
        </el-table-column>
        <el-table-column prop="imgUrl" v-if="queryForm.status!=0"   label="图片">
          <template slot-scope="scope">
            <sp-img :url-arr="scope.row.imgUrl" show-one @get-urlArr="getUrlArr" @active-index="getActiveIndex" />
          </template>
        </el-table-column>
        <el-table-column v-if="queryForm.status==-1"   label="是否拒收">
          <template slot-scope="scope">
            {{scope.row.reject?"是":"否"}}
          </template>
        </el-table-column>
        <el-table-column prop="reason" v-if="queryForm.status==1"   label="备注"></el-table-column>
        <el-table-column prop="reason" v-if="queryForm.status==-1"   label="原因"></el-table-column>
        <el-table-column prop="solution" v-if="queryForm.status==-1"   label="解决办法"></el-table-column>
        <el-table-column prop="operator" v-if="queryForm.status!=0"   label="操作人"></el-table-column>
        <el-table-column prop="operateAt" v-if="queryForm.status!=0"   label="操作时间"></el-table-column>
        <el-table-column label="操作" v-if="queryForm.status!=1"   width="80" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="in_configs(40401) && queryForm.status==0" size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">查货</el-button>
            <el-button v-if="in_configs(40402) && queryForm.status==-1 && !scope.row.solution" size="mini" type="text" @click="changeChannel(scope.row)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <sp-dialog title="" name="" :visible.sync="visible">
        <sp-img-content name="" :urlArr="spImgArr" :activeIndex="activeIndex" @active-index="getActiveIndex"></sp-img-content>
      </sp-dialog>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>

    <el-dialog title="查货" class="common-select__dialog" :visible.sync="dialogTableVisible" :show-close='false' width="600px">
      <el-form :model="checkGoodsData" ref="checkGoodsData" :rules="checkGoodsDataRule" size="small" label-width="80px">
        <el-form-item label="订单号">{{checkGoodsData.orderId}}</el-form-item>
        <el-form-item label="客户名称">{{checkGoodsData.customerName}}</el-form-item>
        <el-form-item label="货物类型" prop="goodsType">
          <el-select v-model="checkGoodsData.goodsType" @change="selectGoodsType()">
            <el-option v-for="(d, i) in goodsType" :key="i" :label="d.name" :value="d.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否拒收" prop="reject">
          <el-radio v-model.lazy="checkGoodsData.reject" :label="true">是</el-radio>
          <el-radio v-model.lazy="checkGoodsData.reject" :label="false">否</el-radio>
        </el-form-item>

        <el-form-item label="加收费用" v-if="!checkGoodsData.reject&&checkGoodsData.goodsType!='common'" prop="tax">
          <div class="extra-charge__content">
            <el-input type="number" min="0" v-model="checkGoodsData.tax" placeholder="加收费用" />
            <el-select v-model="checkGoodsData.currency" placeholder="币种">
              <el-option v-for="(d, i) in currencies" :key="i" :label="d.name" :value="d.value"></el-option>
            </el-select>
            <el-select v-model="checkGoodsData.units" placeholder="单位">
              <el-option label="每千克(kg)" value="kg"></el-option>
              <el-option label="每个(pcs)" value="pcs"></el-option>
              <el-option label="每箱(carton)" value="carton"></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="总个数" v-if="checkGoodsData.units=='pcs'" prop="totalPcs">
          <el-input type="number" min="0" v-model="checkGoodsData.totalPcs">
          </el-input>
        </el-form-item>
        <el-form-item :label="!checkGoodsData.reject || checkGoodsData.goodsType!='common'?'备注':'原因'" :class="{required: checkGoodsData.reject, 'right-half': checkGoodsData.reject}">
          <el-input type="textarea" :autosize="{ minRows: 2}" v-model.trim="checkGoodsData.reason" :placeholder="!checkGoodsData.reject || checkGoodsData.goodsType!='common'?'备注':'拒收原因'"></el-input>
        </el-form-item>
        <el-form-item label="上传图片" ref="uploadPic" class="required">
          <!-- 上传图片 -->
          <el-upload action="#" ref="upload" list-type="picture-card" accept=".jpg,.png,.jpeg" :on-change="handlePictureCardChange" :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelCheck('checkGoodsData')">取 消</el-button>
        <el-button size="small" type="primary" v-show="queryForm.status == 0" @click="checkGoodsDone('checkGoodsData')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="处理异常" :visible.sync="dialogSelectChannel" :show-close='false'>
      <el-form size="small">
        <el-form-item label="处理方法">
          <el-radio-group v-model="dealExceptionMethod" @change="changeMethod">
            <el-radio label="return">全部退回</el-radio>
            <el-radio label="part_return">部分退回</el-radio>
            <el-radio label="change_channel">转换渠道</el-radio>
            <el-radio label="exception_processed">异常已处理</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="return-cartons" v-show="dealExceptionMethod =='part_return'">
          <div class="title">退货箱号</div>
          <el-checkbox-group v-model="selectOrderCartons">
            <el-checkbox v-for="(d, i) in allOrderCartons" :key="i" :label="d" :value="d"></el-checkbox>
          </el-checkbox-group>
        </div>
        <el-form-item label="选择渠道" v-show="dealExceptionMethod =='change_channel'">
          <el-select v-model="changeChannelValue" filterable clearable placeholder="选择渠道" style="width: 375px;">
            <el-option v-for="(d, i) in customerChannelData" :key="i" :label="d.name" :value="d.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogSelectChannel = false">取 消</el-button>
        <el-button size="small" type="primary" @click="changeChannelDone">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var validTax = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error("请填写加收费用并在右侧选择合适的币种和单位！")
        );
      }
      var reg = /^[0-9]+\.?[0-9]{0,9}$/;
      if (!reg.test(value)) {
        return callback(new Error("请输入数字值！"));
      } else {
        if (value <= 0) {
          return callback(new Error("请输入大于0的数字！"));
        } else {
          return callback();
        }
      }
    };
    return {
      isSearchMore: false,
      dialogSelectChannel: false,
      changeChannelValue: "",
      changeChannleOrderId: "",
      changeOrderChannleId: "",
      dealExceptionMethod: "return",
      partReturnCartonsList: [],
      //tag标签
      inputVisible: false,
      partReturnCartons: "",
      orderIds: "",
      multipleOrder: [],
      goodsType: [],
      googsTypeMap: {},
      queryForm: {
          warehouseIds: [],
        orderIds: [],
        status: "0",
        orderStatus: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },
      tmsOrderStages: [],
      tmsOrderStagesMap: {},
      allOrderCartons: [],
      selectOrderCartons: [],
      customers: [],
      customerMaps: {},
      channels: [],
      channelsMaps: {},
      checkGoodImg: [],
      visible: false,
      spImgArr: [],
      activeIndex: null, //当前展示图片的index
      warehouses:[],
        warehouseMap: {},
      currencies: [
        { name: "USD(美元)", value: "USD" },
        { name: "EUR(欧元)", value: "EUR" },
        { name: "CNY(人民币)", value: "CNY" },
        { name: "HKD(港币)", value: "HKD" },
        { name: "JPY(日元)", value: "JPY" }
      ],
      checkGoodsDataRule: {
        goodsType: [
          { required: true, message: "请选择货物类型", trigger: "change" }
        ],
        reject: [
          { required: true, message: "请选择是否拒收", trigger: "change" }
        ],
        tax: [
          { required: true, message: "请输入加收费用", trigger: "blur" },
          { validator: validTax, trigger: "blur" }
        ],
        totalPcs: [{ required: true, message: "请输入总个数", trigger: "blur" }]
      },
      tableData: [],
      checkGoodsData: {
        reject: false
      },
      dialogTableVisible: false,
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      //
      customerChannelData: [],
      //分页的数据
      pageSizes: [10, 20, 50, 100],
      pageSize: 10,
      total: 0,
      currentPage: 1 //当前页
    };
  },
  components: {},
  created() {
    this.getGoodsType();
    setTimeout(() => {
      this.initData();
    }, 1000);
    this.loadTmsOrderStages();
  },
  computed: {},
  methods: {
    loadTmsOrderStages() {
      let _this = this;
      _this.$request1
        .get(
          '/order/tms-order-stage',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          // console.log(res);
          _this.tmsOrderStages = res.data;
          if (_this.tmsOrderStages.length > 0) {
            _this.tmsOrderStages.forEach(c => {
              _this.tmsOrderStagesMap[c.value] = c.name;
            });
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    changeMethod() {
      if (this.dealExceptionMethod != "part_return") {
        this.selectOrderCartons = [];
      }
    },
    //tag标签
    handleArrivaledClose(tag) {
      this.partReturnCartonsList.splice(
        this.partReturnCartonsList.indexOf(tag),
        1
      );
    },
    showArrivaledInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveArrivaledTagInput.$refs.input.focus();
      });
    },
    handleArrivaledInputConfirm() {
      let partReturnCartons = this.partReturnCartons;
      if (partReturnCartons.trim() == "") {
        return;
      }
      if (
        partReturnCartons &&
        this.partReturnCartonsList.indexOf(partReturnCartons) == -1
      ) {
        this.partReturnCartonsList.push(partReturnCartons);
      }
      this.inputVisible = false;
      this.partReturnCartons = "";
    },
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
          _this.query();
        })
      );
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
        _this.warehouses.forEach(a => {
            _this.warehouseMap[a.id] = a.name;
        });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
          {
            withCredentials: true
          }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
          {
            withCredentials: true
          }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
          {
            withCredentials: true
          }
      );
    },
    //获取商品类型
    getGoodsType() {
      let _this = this;
      this.$request1({
        method: 'GET',
        url: '/order/goods-type',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          this.goodsType = data;
          data.forEach((d, i) => {
            this.googsTypeMap[d.code] = d.name;
          });
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },
    //搜索
    searchTask() {
      this.currentPage = 1;
      this.query();
    },
    reset(){
      this.queryForm = {
          warehouseIds: [],
        orderIds: [],
        status: "0",
        orderStatus: [],
        customerIds: [],
        productIds: [],
        startDate: "",
        endDate: "",
        export: 0
      }

    },
    query() {
      let _this = this;
      this.queryForm.orderIds = [];
      if (this.orderIds !== null && this.orderIds !== "") {
        let queryOrderIds = this.orderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.queryForm.orderIds.indexOf(item) == -1) {
              this.queryForm.orderIds.push(item);
            }
          }
        }
      }

      //过滤仓库
        let wlist = [];
        if(this.warehouses!=null && this.warehouses.length>0){
            if(_this.queryForm.warehouseIds && _this.queryForm.warehouseIds.length>0){
                wlist = _this.queryForm.warehouseIds;
            }else{
                wlist = this.warehouses.map(a => a.id);
            }
        }else{
            wlist.push("NOT MATCHING");
        }

      this.$request1({
        method: 'post',
        url: '/operation/check/query',
        withCredentials: true,
        data: {
          orderStatus: this.queryForm.orderStatus,
          orderIds: this.queryForm.orderIds,
          refNumbers: this.queryForm.refNumbers,
          customerIds: this.queryForm.customerIds,
          productIds: this.queryForm.productIds,
          status: this.queryForm.status,
          startDate: this.queryForm.startDate,
          endDate: this.queryForm.endDate,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          export: this.queryForm.export,
            warehouseIds: wlist
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.total = data.total;

            if (this.total > 0) {
              this.tableData = data.data;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            _this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          _this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
    },

    getUrlArr(val) {
      this.visible = true;
      this.spImgArr != val && (this.spImgArr = val);
    },

    //图片组件获取当前index
    getActiveIndex(index) {
      this.activeIndex = index;
      this.$nextTick(function() {
        this.title =
          this.spImgArr.length > 0 && this.spImgArr[index].title
            ? this.spImgArr[index].title
            : "标题";
      });
      // console.log("图片组件获取当前index: " + index);
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleOrder = new Array();
      for (var i = 0; i < val.length; i++) {
        this.multipleOrder.push(val[i].orderId);
      }
    },
    // 导出客户申报品名
    exportSku() {
      if (!this.multipleOrder || this.multipleOrder.length == 0) {
        this.$message.error("请选择订单");
        return false;
      }
      this.$windowOpen1(
        '/operation/export' +
          "?orderIds=" +
          this.multipleOrder.toString()
      );
    },
    //编辑
    handleEdit(index, row) {
      // console.log(index, row);
      if (this.queryForm.status == 1) {
        this.checkGoodsData = {
          orderId: row.orderId,
          customer: row.customer,
          customerName: this.customerMaps[row.orgOwner],
          goodsType: row.changedGoodsType,
          units: row.units,
          currency: row.currency,
          totalPcs: row.totalPcs
        };
      } else {
        this.checkGoodsData = {
          orderId: row.orderId,
          customer: row.customer,
          customerName: this.customerMaps[row.orgOwner],
          goodsType: row.goodsType,
          reject: false,
          units: "kg",
          currency: "CNY",
          totalPcs: row.totalPcs
        };
      }
      this.checkGoodsData.tax = "";
      this.checkGoodImg = [];
      this.dialogTableVisible = true;
    },
    //  转换渠道
    changeChannel(row) {
      this.changeChannelValue = "";
      this.changeChannleOrderId = row.orderId;
      this.changeOrderChannleId = row.product;
      this.dealExceptionMethod = "return";
      this.allOrderCartons = [];
      this.selectOrderCartons = [];
      //查询订单的所有箱号
      this.$request1({
        method: 'GET',
        url: '/operation/measure/' + row.orderId + '/edit/detail',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.length > 0) {
            data.forEach((car, index) => {
              this.allOrderCartons.push(car.cartonNumber);
            });
            this.allOrderCartons.sort();
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "错误",
            message: error.response.data
          });
        });
      this.getCustomerChannel(row.orgOwner);
      this.dialogSelectChannel = true;
    },
    getCustomerChannel(orgOwnerId) {
      this.customerChannelData = [];
      this.$request1({
        method: 'GET',
        url: '/channel/getChannel',
        params: {
          orgOwnerId: orgOwnerId
        }
      })
        .then(response => {
          console.log(response);
          this.customerChannelData = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //确定转换渠道
    changeChannelDone() {
      let niticeMsg = "";
      if (this.dealExceptionMethod === "return") {
        this.changeChannelValue = "";
        niticeMsg = "确定退回此订单？";
        this.selectOrderCartons = [];
      } else if (
        this.dealExceptionMethod === "part_return" &&
        this.selectOrderCartons.length == 0
      ) {
        this.$notify.error({
          title: "错误",
          message: "请填写退回箱号"
        });
        return;
      } else if (
        this.dealExceptionMethod === "part_return" &&
        this.selectOrderCartons.length > 0
      ) {
        niticeMsg = "确定退回此订单部分箱？";
      } else if (
        this.dealExceptionMethod === "change_channel" &&
        this.changeChannelValue === ""
      ) {
        this.$notify.error({
          title: "错误",
          message: "请选择渠道"
        });
        return;
      } else if (
        this.dealExceptionMethod === "change_channel" &&
        this.changeChannelValue != ""
      ) {
        if (this.changeChannelValue == this.changeOrderChannleId) {
          this.$notify.error({
            title: "错误",
            message: "请选择与订单不同的渠道"
          });
          return;
        }
        this.selectOrderCartons = [];
        niticeMsg = "确定转换渠道？";
      } else if (this.dealExceptionMethod === "exception_processed") {
        this.changeChannelValue = "";
        niticeMsg = "确定此订单异常已处理？";
        this.selectOrderCartons = [];
      }

      this.$confirm(niticeMsg, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'post',
            url: '/operation/check/deal-with',
            data: {
              orderId: this.changeChannleOrderId,
              method: this.dealExceptionMethod,
              newChannelId: this.changeChannelValue,
              returnCartonCodes: this.selectOrderCartons
            },
            withCredentials: true
          })
            .then(response => {
              if (response.data.success) {
                this.$notify({
                  title: "成功",
                  message: "处理成功",
                  type: "success"
                });
                this.query();
                this.dialogSelectChannel = false;
              } else {
                this.$notify.error({
                  title: "错误",
                  message: response.data.message
                });
              }
            })
            .catch(error => {
              this.$notify.error({
                title: "错误",
                message: error.response.data
              });
            });
        })
        .catch(() => {
          console.log("取消");
        });
    },

    //改变货物类型
    selectGoodsType() {
      //清除图片
      this.$refs.upload.clearFiles();
      this.checkGoodsData.tax = "";
      this.checkGoodImg = [];
    },
    cancelCheck(formName) {
      this.$refs[formName].clearValidate();
      this.dialogTableVisible = false;
      this.checkGoodsData = {};
    },
    checkGoodsDone(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // if (
          //   !this.checkGoodsData.reject &&
          //   this.checkGoodsData.goodsType != "common" &&
          //   this.checkGoodsData.tax <= 0
          // ) {
          //   this.$notify.info({
          //     title: "提示",
          //     message: "请输入正确的税费"
          //   });
          //   return;
          // }
          // if (
          //   !this.checkGoodsData.reject &&
          //   this.checkGoodsData.goodsType != "common" &&
          //   this.checkGoodsData.currency == ""
          // ) {
          //   this.$notify.info({
          //     title: "提示",
          //     message: "请选择币种"
          //   });
          //   return;
          // }
          // if (
          //   !this.checkGoodsData.reject &&
          //   this.checkGoodsData.goodsType != "common" &&
          //   this.checkGoodsData.units == ""
          // ) {
          //   this.$notify.info({
          //     title: "提示",
          //     message: "请选择单位"
          //   });
          //   return;
          // }
          // if (
          //   !this.checkGoodsData.reject &&
          //   this.checkGoodsData.goodsType != "common" &&
          //   this.checkGoodsData.units == "pcs" &&
          //   this.checkGoodsData.totalPcs <= 0
          // ) {
          //   this.$notify.info({
          //     title: "提示",
          //     message: "请输入正确的总个数"
          //   });
          //   return;
          // }

          if (
            this.checkGoodsData.reject &&
            this.checkGoodsData.reason === undefined
          ) {
            this.$notify.error({
              title: "错误",
              message: "请填写拒绝原因"
            });
            return false;
          }
          if (this.checkGoodImg.length === 0) {
            this.$notify.error({
              title: "错误",
              message: "请上传图片"
            });
            return false;
          }
          if (this.checkGoodsData.goodsType == "common") {
            this.checkGoodsData.tax = "";
          }

          let dataForm = this.getFormData(
            this.checkGoodsData,
            this.checkGoodImg
          );
          this.$request1({
            method: 'post',
            url: '/operation/check',
            data: dataForm,
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "操作成功",
                  type: "success"
                });
                this.dialogTableVisible = false;
                this.checkGoodsData = {};
                this.$refs.upload.clearFiles();
                this.checkGoodImg = [];
                setTimeout(() => {
                  this.query();
                }, 1500);
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              this.$notify.error({
                title: "错误",
                message: error.response.data
              });
            });
        }
      });
    },
    getFormData(doneData, img) {
      var formData = new FormData();
      for (var key in doneData) {
        formData.append(key, doneData[key]);
      }
      img.forEach((img, index) => {
        formData.append(img.uid, img.raw);
      });
      return formData;
    },

    //上传图片
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handlePictureCardChange(file, fileList) {
      this.checkGoodImg = fileList;
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.query();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.query();
    }
  }
};
</script>

<style lang="scss">
.box-card {
  margin: 20px -10px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.return-cartons {
  display: flex;
  .title {
    width: 68px;
  }
  .el-checkbox-group {
    flex: 1;
    .el-checkbox {
      width: 33%;
    }
    .el-checkbox + .el-checkbox {
      margin-left: 0;
    }
  }
}
.required .el-form-item__label {
  position: relative;
  &::before {
    content: "*";
    display: block;
    position: absolute;
    top: 0;
    right: 70px;
    color: #f56c82;
  }
}
.right-half .el-form-item__label::before {
  right: 50px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/checkgoods.vue